import { ru as leafletCreation } from '@/modules/leaflet-creation/messages'

export default {
  leafletCreation,
  shared: {
    ok: 'OK',
    cancel: 'Отмена',
    close: 'Закрыть',
    create: 'Создать',
    update: 'Обновить',
    edit: 'Редактировать',
    save: 'Сохранить',
    delete: 'Удалить',
    warning: 'Предупреждение',
    devices: {
      android: 'Android',
      androidMG: 'Moja Gazetka (Android)',
      androidMP: 'mPromocje (Android2)',
      iOS: 'iOS',
      ios: 'iOS',
      web: 'Web',
      wp: 'WP',
      android2: {
        'dev-1-pl': 'mPromocje',
        'dev-1-ua': 'Love Sales Light',
        'preprod-pl': 'mPromocje',
        'preprod-ua': 'Love Sales Light',
        'local': 'mPromocje',
        'pl': 'mPromocje',
        'ua': 'Love Sales Light'
      }
    },
    loading: 'посадка...'
  },
  expand: 'Развернуть',
  collapse: 'Свернуть',
  common: {
    update: 'Обновить',
    cancel: 'Отмена',
    confirm: 'Подтвердить',
    create: 'Создать',
    delete: 'Удалить',
    apply: 'Применить',
    copyToClipboard: 'Копировать в буфер обмена',
    copiedToClipboard: 'Скопировано в буфер обмена',
    copyFailed: 'Не удалось скопировать в буфер обмена',
    clickToViewDetails: 'Нажмите, чтобы посмотреть подробности'
  },
  locationGroups: {
    manage: 'Пресеты локаций',
    title: 'Пресеты локаций — {store}',
    create: 'Создать пресет',
    empty: 'Нет пресетов',
    fields: { name: 'Название', available: 'Доступные локации', unavailable: 'Исключённые локации' },
    availableCount: 'Доступные: {count}',
    unavailableCount: 'Исключённые: {count}',
    editAria: 'Изменить пресет {name}',
    deleteAria: 'Удалить пресет {name}',
    deleteConfirm: 'Удалить пресет «{name}»?',
    validation: {
      name: 'Введите название пресета',
      invalidLocations: 'Исправьте неверные локации',
      locationsRequired: 'Добавьте хотя бы одну локацию'
    },
    notice: { saved: 'Сохранено', savedReloadFailed: 'Сохранено, обновить не удалось' },
    errors: {
      duplicateName: 'Пресет с таким названием уже существует',
      exists: 'Пресет уже существует',
      notFound: 'Пресет не найден',
      invalid: 'Неверные данные пресета',
      unauthorized: 'Сессия истекла',
      forbidden: 'Нет доступа',
      server: 'Ошибка сервера',
      network: 'Ошибка сети',
      unexpectedStatus: 'Неожиданный ответ сервера',
      unknown: 'Не удалось выполнить операцию',
      load: 'Не удалось загрузить пресеты'
    },
    selector: {
      placeholder: 'Выберите пресет',
      apply: 'Применить',
      confirmReplace: 'Заменить текущие локации листовки?'
    },
    saveAs: { label: 'Сохранить как пресет локаций', action: 'Сохранить' }
  },
  notification: {
    success: 'Успех',
    error: 'Ошибка',
    info: 'Info',
    priorityUnavailable: 'Акция для {os} уже существует с позицией номер {priorityNumber} (id: {naturalId})',
    failedToProcessFile:
      'Неудалось обработать файлы. Убедись, что файлы в соответствующем формате (одинарный файл .pdf или много файлов .jpg/.png)',
    unknownError: 'Неизвестная ошибка'
  },
  errorMessages: {
    unknownError: 'Unknown error.',
    leafletNotFound: 'Leaflet with inserted ID not found.',
    invalidSession: 'Session has expired. Log in again.'
  },
  route: {
    dashboard: 'Доска',
    selectiveNotifications: 'Выборочные уведомления',
    users: 'Пользователи',
    leaflets: 'Газетки',
    pageDetails: 'Детали страниц',
    productHits: 'Хиты продуктов',
    inserts: 'Вставки',
    logs: 'Логи',
    groups: 'Groups',
    archives: 'Архивы',
    leafletsArchive: 'Leaflets archive',
    leafletsAlternative: 'Leaflets archive',
    shopsArchive: 'Shops archive',
    shopsAlternative: 'Shops',
    notificationsArchive: 'Notifications archive',
    notificationsAlternative: 'Notifications',
    leafletDetails: 'Leaflet details archive',
    leafletAlternative: 'Leaflet details',
    insertsAlternative: 'Вставки',
    insertsArchive: 'Архив вставок',
    password: 'Изменить пароль',
    categories: 'Категории',
    xmlOffers: 'Порядок расположения акций',
    cooksAndRecipes: 'Cooks and recipes',
    scrapper: 'Scrapper',
    scrapperNewLeafletsSearch: 'Search for new leaflets',
    reels: 'Reels',
    loyaltyCards: 'Карты лояльности',
    appConfig: 'Конфигурация приложения',
    slider: 'Слайдер',
    tradeDays: 'Торговые дни',
    productCategories: 'Категории товаров'
  },
  appConfig: {
    title: 'Удаленная конфигурация',
    subtitle: 'Управление удаленными конфигурациями для мобильных и веб-приложений',
    platforms: {
      all: 'Все платформы',
      ios: 'iOS',
      android: 'Android',
      web: 'Web'
    },
    webPopularCities: {
      sectionTitle: 'Популярные города в веб-приложении',
      subtitle: 'Настройка популярных городов, отображаемых в веб-приложении',
      citiesConfig: 'Конфигурация городов',
      dragHint: 'Перетащите, чтобы изменить порядок городов',
      city: 'Город',
      addCity: 'Добавить город',
      saveChanges: 'Сохранить изменения',
      resetChanges: 'Сбросить изменения',
      saveSuccess: 'Конфигурация городов успешно сохранена',
      saveError: 'Ошибка при сохранении конфигурации городов',
      loadingError: 'Ошибка загрузки данных',
      loadingErrorDesc: 'Не удалось загрузить конфигурацию популярных городов',
      tryAgain: 'Попробовать снова',
      validationErrors: 'Ошибки валидации',
      validation: {
        cityRequired: 'Название города обязательно',
        cityMinLength: 'Название города должно содержать минимум 1 символ'
      }
    },
    webFooterLinks: {
      sectionTitle: 'Ссылки в футере веб-приложения',
      subtitle: 'Настройка ссылок в футере для веб-приложения',
      storesPopular: 'Популярные магазины',
      locationsPopular: 'Популярные локации',
      articlesPopular: 'Популярные статьи',
      dragHint: 'Перетащите, чтобы изменить порядок ссылок',
      linkName: 'Название ссылки',
      linkUrl: 'URL ссылки',
      addLink: 'Добавить ссылку',
      saveChanges: 'Сохранить изменения',
      resetChanges: 'Сбросить изменения',
      saveSuccess: 'Конфигурация ссылок в футере успешно сохранена',
      saveError: 'Ошибка при сохранении конфигурации ссылок в футере',
      loadingError: 'Ошибка загрузки данных',
      loadingErrorDesc: 'Не удалось загрузить конфигурацию ссылок в футере',
      tryAgain: 'Попробовать снова',
      validationErrors: 'Ошибки валидации',
      validation: {
        nameRequired: 'Название ссылки обязательно',
        nameMinLength: 'Название ссылки должно содержать минимум 1 символ',
        urlRequired: 'URL ссылки обязателен',
        urlMinLength: 'URL ссылки должен содержать минимум 1 символ'
      }
    },
    aiConfiguration: {
      sectionTitle: 'Конфигурация AI',
      subtitle: 'Настройте параметры AI для обработки распознавания предложений',
      noConfig: 'Для этой страны не существует конфигурации AI',
      createConfig: 'Создать конфигурацию',
      provider: 'Провайдер AI',
      selectProvider: 'Выберите провайдера AI',
      model: 'Модель AI',
      selectModel: 'Выберите модель AI',
      prompt: 'Подсказка',
      promptPlaceholder: 'Введите подсказку AI для распознавания предложений...',
      promptHint:
        'Эта подсказка будет отправлена в модель AI для направления распознавания предложений. Будьте конкретны в отношении ожидаемого формата вывода.',
      pagePrompt: 'Подсказка для страницы (необязательно)',
      pagePromptPlaceholder: 'Введите подсказку для определения дат действия предложений на странице каталога...',
      pagePromptHint: 'Инструкция для чтения дат со всей страницы каталога. Пустое поле сохраняет пустую подсказку.',
      currency: 'Валюта распознаваемых предложений (необязательно)',
      currencyPlaceholder: 'Код валюты, например PLN',
      currencyHint:
        'Введите трёхбуквенный код валюты. Он будет сохранён заглавными буквами. При редактировании пустое поле оставляет текущую валюту.',
      units: 'Единицы измерения',
      addUnit: 'Добавить единицу',
      unitsHint: 'Единицы, используемые для измерений продуктов (например, кг, г, л, мл, шт)',
      suggestedUnits: 'Предложенные',
      metadata: 'Метаданные конфигурации',
      country: 'Страна',
      createdDate: 'Создано',
      lastModified: 'Последнее изменение',
      create: 'Создать конфигурацию',
      saveChanges: 'Сохранить изменения',
      resetChanges: 'Сбросить',
      saveSuccess: 'Конфигурация AI успешно сохранена',
      saveError: 'Ошибка при сохранении конфигурации AI',
      saveFailed: 'Не удалось сохранить конфигурацию. Пожалуйста, попробуйте еще раз.',
      invalidData: 'Некорректные данные конфигурации',
      noPermission: 'У вас нет разрешения на изменение этой конфигурации',
      validationError: 'Пожалуйста, исправьте ошибки валидации',
      validationErrors: 'Ошибки валидации',
      loadingError: 'Ошибка загрузки конфигурации AI',
      loadingErrorDesc: 'Не удалось загрузить конфигурацию AI',
      tryAgain: 'Попробовать снова',
      validation: {
        providerRequired: 'Провайдер обязателен',
        providerInvalid: 'Провайдер должен иметь значение OPENAI, GOOGLE или DEEPSEEK',
        currencyInvalid: 'Код валюты должен состоять ровно из трёх букв',
        modelRequired: 'Модель обязательна',
        modelInvalid: 'Модель может содержать только буквы, цифры, дефисы и точки',
        promptMinLength: 'Подсказка должна содержать минимум 10 символов',
        unitInvalid: 'Единицы могут содержать только буквенно-цифровые символы'
      }
    },
    roboflow: {
      sectionTitle: 'Синхронизация Roboflow',
      subtitle: 'Отправьте страницы каталогов из очереди в обучающий набор Roboflow.',
      maxImagesNumber: 'Максимальное количество изображений',
      maxImagesNumberHint: 'Максимальное количество изображений из очереди для этой операции.',
      store: 'Магазин (необязательно)',
      allStores: 'Все магазины',
      storeHint: 'Оставьте поле пустым, чтобы синхронизировать изображения без фильтра по магазину.',
      storesLoadingError: 'Не удалось загрузить магазины. Синхронизация всех магазинов остается доступной.',
      synchronize: 'Запустить синхронизацию',
      confirmTitle: 'Запустить синхронизацию Roboflow?',
      confirmMessage: 'Для отправки будет выбрано до {count} изображений. Магазин: {store}.',
      synchronizeSuccess: 'Синхронизация изображений из очереди запущена.',
      synchronizeError: 'Не удалось запустить синхронизацию Roboflow.',
      validation: {
        maxImagesNumber: 'Количество изображений должно быть положительным целым числом.'
      }
    },
    accordions: {
      articles: 'Конфигурация списка статей',
      articlesSection: 'Настройки раздела статей',
      mobileWhatsNewBanner: 'Баннер "Что нового" в мобильном приложении',
      searchSettings: 'Настройки поиска',
      mobileRecommendationType: 'Тип мобильных рекомендаций',
      mobileRecommendationHighlightedLeafletId: 'ID выделенного каталога',
      mobileRecommendationCustomTypeLink: 'Ссылка на нестандартный тип',
      mobileRecommendationCustomTypePictureUrl: 'URL изображения нестандартного типа',
      webPopularCities: 'Web - Популярные города',
      webLeafletView: 'Web - Просмотр каталога',
      notifications: 'Конфигурация уведомлений',
      appearance: 'Конфигурация внешнего вида',
      custom: 'Пользовательские конфигурации',
      aiConfiguration: 'Конфигурация AI',
      roboflow: 'Синхронизация Roboflow'
    },
    form: {
      platformLabel: 'Выберите платформу'
    },
    articlesSectionSettings: {
      title: 'Настройки раздела статей',
      subtitle: 'Настройте параметры разделов статей в приложении',
      noConfig: 'Нет конфигурации для отображения',
      noValue: 'Нет значения',
      addSection: 'Добавить раздел',
      iconUrl: 'URL иконки',
      useBigSize: 'Использовать большой размер',
      position: 'Позиция',
      saveChanges: 'Сохранить изменения',
      saveError: 'Ошибка при сохранении',
      saveSuccess: 'Конфигурация успешно сохранена',
      loadingError: 'Ошибка загрузки данных',
      loadingErrorDesc: 'Не удалось получить настройки раздела',
      tryAgain: 'Попробовать снова',
      validation: {
        titleRequired: 'Заголовок обязателен',
        titleMinLength: 'Заголовок должен содержать не менее 3 символов',
        iconUrlRequired: 'URL иконки обязателен',
        iconUrlInvalid: 'URL иконки должен быть действительным URL-адресом',
        positionRequired: 'Позиция обязательна',
        positionInvalid: 'Позиция должна быть целым числом'
      }
    },
    mobileWhatsNewBanner: {
      sectionTitle: 'Баннер "Что нового" в мобильном приложении',
      subtitle: 'Настройте баннер "Что нового", отображаемый в мобильных приложениях',
      noConfig: 'Нет конфигурации для отображения',
      noValue: 'Нет значения',
      addBanner: 'Добавить баннер',
      clearBanner: 'Очистить баннер',
      bannerConfig: 'Конфигурация баннера',
      id: 'ID',
      title: 'Заголовок',
      message: 'Сообщение',
      deeplink: 'Deeplink',
      badge: 'Значок',
      saveChanges: 'Сохранить изменения',
      resetChanges: 'Сбросить изменения',
      saveError: 'Ошибка при сохранении',
      validationErrors: 'Ошибки валидации',
      saveSuccess: 'Конфигурация успешно сохранена',
      loadingError: 'Ошибка загрузки данных',
      loadingErrorDesc: 'Не удалось получить настройки баннера',
      tryAgain: 'Попробовать снова',
      validation: {
        idMinLength: 'ID должен содержать не менее 3 символов',
        titleMinLength: 'Заголовок должен содержать не менее 3 символов',
        messageMinLength: 'Сообщение должно содержать не менее 3 символов',
        deeplinkMinLength: 'Deeplink должен содержать не менее 3 символов',
        badgeMinLength: 'Значок должен содержать не менее 3 символов'
      }
    },
    searchSettings: {
      sectionTitle: 'Настройки поиска',
      subtitle: 'Настройте параметры поиска для мобильных приложений',
      noConfig: 'Нет конфигурации для отображения',
      noValue: 'Нет значения',
      addSettings: 'Добавить настройки',
      clearSettings: 'Очистить настройки',
      settingsConfig: 'Конфигурация настроек поиска',
      includeAdBanner: 'Включить рекламный баннер',
      searchTip: 'Подсказка поиска',
      popularWords: 'Популярные слова',
      addWord: 'Добавить слово',
      includePopularStores: 'Включить популярные магазины',
      popularStores: 'Популярные магазины',
      addStore: 'Добавить магазин',
      includePopularLeaflets: 'Включить популярные листовки',
      popularLeaflets: 'Популярные листовки',
      addLeaflet: 'Добавить листовку',
      saveChanges: 'Сохранить изменения',
      resetChanges: 'Сбросить изменения',
      saveError: 'Ошибка при сохранении',
      validationErrors: 'Ошибки валидации',
      validation: {
        searchTipRequired: 'Подсказка поиска не может быть пустой'
      },
      saveSuccess: 'Конфигурация успешно сохранена',
      loadingError: 'Ошибка загрузки данных',
      loadingErrorDesc: 'Не удалось получить настройки поиска',
      tryAgain: 'Попробовать снова'
    },
    mobileRecommendationType: {
      sectionTitle: 'Тип мобильных рекомендаций',
      subtitle: 'Настройка типов рекомендаций для мобильных приложений',
      noConfig: 'Нет конфигурации для отображения',
      noValue: 'Нет значения',
      addRecommendationType: 'Добавить тип рекомендаций',
      clearRecommendationType: 'Очистить тип рекомендаций',
      recommendationConfig: 'Конфигурация типа рекомендаций',
      value: 'Тип рекомендаций',
      saveChanges: 'Сохранить изменения',
      resetChanges: 'Сбросить изменения',
      saveError: 'Ошибка при сохранении',
      validationErrors: 'Ошибки валидации',
      validation: {
        valueRequired: 'Пожалуйста, выберите тип рекомендаций',
        invalidValue: 'Пожалуйста, выберите действительный тип рекомендаций',
        pictureUrlRequired:
          'Вы должны установить URL-адрес изображения перед использованием типа Изображение со ссылкой. Перейдите в раздел URL-адрес изображения нестандартного типа и установите действительный URL-адрес.',
        linkRequired:
          'Вы должны установить ссылку перед использованием типа Изображение со ссылкой. Перейдите в раздел Ссылка нестандартного типа и установите действительную ссылку.'
      },
      options: {
        singleLeaflet: 'Одиночный каталог',
        fourLeaflets: 'Четыре каталога',
        leafletsAndStores: 'Каталоги и магазины',
        leafletsStoreRating: 'Каталоги с рейтингом магазина',
        twoLeafletsThreeStoresRating: 'Два каталога и три магазина с рейтингом',
        twoLeafletsFavouriteRating: 'Два каталога с избранным и рейтингом',
        twoLeafletsFavouriteThreeStores: 'Два каталога с избранным и три магазина',
        imageWithLink: 'Изображение со ссылкой'
      },
      untitled: 'Без названия',
      saveSuccess: 'Конфигурация успешно сохранена',
      loadingError: 'Ошибка загрузки данных',
      loadingErrorDesc: 'Не удалось загрузить настройки типа рекомендаций',
      tryAgain: 'Попробовать снова'
    },
    mobileRecommendationHighlightedLeafletId: {
      sectionTitle: 'ID выделенного каталога',
      subtitle: 'Настройка ID выделенного каталога для мобильных приложений',
      noConfig: 'Нет конфигурации для отображения',
      highlightedLeafletConfig: 'Конфигурация ID выделенного каталога',
      value: 'ID каталога',
      saveChanges: 'Сохранить изменения',
      resetChanges: 'Сбросить изменения',
      saveError: 'Ошибка при сохранении',
      validationErrors: 'Ошибки валидации',
      saveSuccess: 'Конфигурация успешно сохранена',
      loadingError: 'Ошибка загрузки данных',
      loadingErrorDesc: 'Не удалось загрузить настройки ID выделенного каталога',
      tryAgain: 'Попробовать снова'
    },
    mobileRecommendationCustomTypeLink: {
      sectionTitle: 'Ссылка на нестандартный тип',
      subtitle: 'Настройка ссылки на нестандартный тип для мобильных приложений',
      disclaimer: 'Важно:',
      disclaimerText:
        'Эта конфигурация применяется только когда тип рекомендации установлен на "Изображение со ссылкой" (тип 7).',
      noConfig: 'Нет конфигурации для отображения',
      customTypeLinkConfig: 'Конфигурация ссылки на нестандартный тип',
      value: 'Значение ссылки',
      saveChanges: 'Сохранить изменения',
      resetChanges: 'Сбросить изменения',
      saveError: 'Ошибка при сохранении',
      validationErrors: 'Ошибки валидации',
      saveSuccess: 'Конфигурация успешно сохранена',
      loadingError: 'Ошибка загрузки данных',
      loadingErrorDesc: 'Не удалось загрузить настройки ссылки на нестандартный тип',
      tryAgain: 'Попробовать снова'
    },
    mobileRecommendationCustomTypePictureUrl: {
      sectionTitle: 'URL изображения нестандартного типа',
      subtitle: 'Настройка URL изображения нестандартного типа для мобильных приложений',
      disclaimer: 'Важно:',
      disclaimerText:
        'Эта конфигурация применяется только когда тип рекомендации установлен на "Изображение со ссылкой" (тип 7).',
      noConfig: 'Нет конфигурации для отображения',
      customTypePictureUrlConfig: 'Конфигурация URL изображения нестандартного типа',
      value: 'URL изображения',
      preview: 'Предварительный просмотр',
      imageLoadError: 'Не удалось загрузить изображение. Проверьте URL.',
      saveChanges: 'Сохранить изменения',
      resetChanges: 'Сбросить изменения',
      saveError: 'Ошибка при сохранении',
      validationErrors: 'Ошибки валидации',
      validation: {
        urlInvalid: 'URL должен быть действительным'
      },
      saveSuccess: 'Конфигурация успешно сохранена',
      loadingError: 'Ошибка загрузки данных',
      loadingErrorDesc: 'Не удалось загрузить настройки URL изображения нестандартного типа',
      tryAgain: 'Попробовать снова',
      uploadImage: 'Загрузить изображение',
      imageUploadSuccess: 'Изображение успешно загружено',
      imageUploadError: 'Ошибка при загрузке изображения'
    },
    articlesList: {
      title: 'Конфигурация списка статей',
      subtitle: 'Настройте статьи, которые отображаются в приложении',
      noConfig: 'Нет конфигурации для отображения',
      noValue: 'Нет значения',
      addArticles: 'Добавить статьи',
      article: 'Статья',
      dragHint: 'Перетащите, чтобы изменить порядок статей',
      additionalInfo: 'Дополнительная информация',
      imageUrl: 'URL изображения',
      articleUrl: 'URL статьи',
      isSponsored: 'Спонсируемый',
      addArticle: 'Добавить статью',
      addArticleAtBeginning: 'Добавить статью в начало',
      addArticleAtEnd: 'Добавить статью в конец',
      saveChanges: 'Сохранить изменения',
      resetChanges: 'Сбросить изменения',
      saveError: 'Ошибка при сохранении',
      saveSuccess: 'Конфигурация успешно сохранена',
      copySuccess: 'Конфигурация успешно скопирована',
      copyError: 'Ошибка при копировании конфигурации',
      configDifference: 'Обнаружены различия в конфигурации',
      validation: {
        titleRequired: 'Заголовок обязателен',
        titleMinLength: 'Заголовок должен содержать не менее 3 символов',
        additionalInfoRequired: 'Дополнительная информация обязательна',
        imageUrlRequired: 'URL изображения обязателен',
        imageUrlInvalid: 'URL изображения должен быть действительным URL-адресом',
        articleUrlRequired: 'URL статьи обязателен',
        articleUrlInvalid: 'URL статьи должен быть действительным URL-адресом'
      },
      configDifferenceDescription:
        'Конфигурации Android и iOS отличаются. Вы можете скопировать конфигурацию Android в iOS.',
      copyToIos: 'Копировать в iOS',
      allArticlesRemoved: 'Все статьи были удалены',
      articlesCount: '{count} статья(ей)',
      loadingError: 'Ошибка загрузки данных',
      loadingErrorDesc: 'Не удалось получить список статей',
      tryAgain: 'Попробовать снова',
      uploadImage: 'Загрузить изображение',
      imageUploadSuccess: 'Изображение успешно загружено',
      imageUploadError: 'Ошибка при загрузке изображения',
      basic: 'БАЗОВЫЙ'
    }
  },
  selectiveNotifications: {
    addNotification: 'Add notification',
    notificationId: 'Notification Id',
    plannedTime: 'Planned time',
    channel: 'канал',
    title: 'заголовок',
    devices: 'платформы',
    saveSuccess: 'Notification saved successfully',
    deleteSuccess: 'Notification removed successfully',
    deleteConfirm: 'Are you sure you want to remove this notification?'
  },
  dashboard: {
    title: 'Магазины и каталоги',
    preventCloseTab: 'Do you really want to leave? You will lost unsaved changes!',
    nothing: 'Нет данных',
    missingLeafletForStore: 'Отсутствуют каталоги',
    actions: 'Акции',
    publicationPlanned: 'Публикация запланирована',
    leafletProcessing: {
      pending: 'Ожидает обработки',
      processing: 'Обработка каталога...',
      failed: 'Ошибка обработки',
      failedHint: 'Не удалось создать изображения каталога. Откройте каталог и повторите попытку.'
    },
    search: {
      placeholder: 'Поиск магазина, ID каталога или названия каталога'
    },
    storesWithoutLeaflets: {
      title: 'Магазины без каталогов'
    },
    productsToCheck: {
      title: 'Товары для проверки'
    },
    xml: {
      button: 'Опубликовать Акции',
      confirm: 'Вы действительно хотите опубликовать Акции?',
      success: 'Акции успешно опубликованы',
      successWithNotifications: 'Акции успешно опубликованы\nУведомление выслано успешно для',
      allPlatforms: 'Все платформы',
      inProgress: 'Акции в процессе публикации. Мы сообщим вам, когда процесс публикации будет завершен.',
      inProgressWithNotification:
        'Акции в процессе публикации. Мы сообщим вам, когда процесс публикации будет завершен.',
      generateNotificationsInProgress:
        'Notifications are being generated. We will notify you when the publication process is complete.',
      lastGenerated: 'Последняя публикация изменений',
      generatedBy: 'by'
    },
    xmlAndNotifications: {
      button: 'Опубликовать Акции и Выслать уведомление пользователям',
      confirm: 'Вы действительно хотите опубликовать Акции и выслать уведомление?'
    },

    activation: {
      success: 'Leaflet is ready for activation.'
    },
    cutRequest: {
      request: 'Запросить вырезку',
      retry: 'Повторить',
      cutAgain: 'Вырезать снова',
      rerun: 'Повторить вырезку',
      rerunConfirmTitle: 'Повторить вырезку?',
      rerunConfirmMessage:
        'Повторная вырезка обработает всю листовку заново и может заменить текущие предложения и ручные правки.',
      rerunConfirmConfirm: 'Повторить вырезку',
      success: 'Запрос на вырезку успешно отправлен',
      error: 'Ошибка при отправке запроса на вырезку',
      featureDisabled: 'Функция распознавания предложений отключена'
    },
    cutStatus: {
      checking: 'Проверка статуса...',
      processing: 'Обработка',
      pending: '{count} страниц в процессе',
      complete: 'Готово',
      toFix: 'К исправлению ({count})',
      failed: 'Вырезка не удалась ({count} страниц) - Повторить',
      error: 'Не удалось проверить статус - Повторить'
    },
    leafletStatus: {
      successPages: 'Нарезанные:',
      errorPages: 'Не нарезанные:',
      pendingPages: 'В процессе:',
      pageTooltip: 'Страница {pageNumber}: {status}',
      statusText: {
        SUCCESS: 'Успешно вырезана',
        FAILED: 'Ошибка',
        IN_PROGRESS: 'В процессе'
      }
    },
    notifications: {
      button: 'Выслать уведомление пользователям',
      buttonSelect: 'Выборочные уведомления',
      confirm: 'Действительно хочешь выслать уведомление?',
      success: 'Уведомление выслано успешно для',
      selectedShopsTitle: 'Выслать уведомление для выборочных магазинов',
      selectedShopsTitleEdit: 'Edit notification',
      selectAll: 'Выбрать все',
      selectAllGroups: 'Select all groups',
      selectShops: 'Select shops',
      selectGroups: 'Select groups',
      selectedShops: 'магазины',
      selectedGroups: 'группы',
      form: {
        id: 'Notification ID:',
        titleLabel: 'Title:',
        titlePlaceholder: 'Insert title',
        textLabel: 'Message:',
        channel: 'Channel',
        bigIcon: 'Big icon URL',
        bigPicture: 'Big picture URL',
        uploadImage: 'Select image',
        deepLink: 'Deep link',
        webpageLink: 'Webpage link',
        showTrackingLink: 'Show tracking link',
        openTrackingLink: 'Open tracking link',
        geoLocations: 'Geolocations',
        devices: 'Отправка для',
        specialOffer: {
          description: 'Специальное предложение',
          details: 'Игнорирует настройки магазинов ulubionych'
        },
        errors: {
          titleRequiredForChannels:
            'Notification title is required if channel is different than NEW_OFFERS_NOTIFICATION',
          invalidGeolocationsFormat:
            'Invalid geolocation format. There should be 3 elements in one line separated by comma',
          invalidLatitudeValue: 'Latitude should be between -90.0000000 and 90.0000000',
          invalidLongitudeValue: 'Longitude should be between -180.0000000 and 180.0000000',
          invalidRadiusValue: 'Radius should be a positive number',
          invalidUrlValue: 'Invalid URL',
          newOffersNotificationSet: 'Value must be empty if channel is set to NEW_OFFERS_NOTIFICATION',
          shopsRequired: 'At least one shop or group must be selected',
          devicesRequired: 'Требуется хотя бы одна платформа'
        }
      }
    },
    planNotifications: {
      title: 'Plan notification',
      dateLabel: 'for day',
      hourLabel: 'for hour',
      saveLabel: 'Schedule',
      successMessage: 'Notification is scheduled'
    },
    articlesData: {
      unmatchedData: 'Unmatched leaflests',
      noUnmatchedData: 'There are no mismatched leaflets.',
      restoreArticles: 'Restore deleted leaflets',
      restoreArticlesSuccess: 'Leaflet successfully restored',
      restoreArticlesInfo:
        'Restores the deleted leaflets to IMPORTED status. Only actual (valid) leaflets can be restored.',
      noLeafletsToRestore: 'There are no leaflets to restore.',
      removeConfirm: 'Are you sure you want to remove this leaflet?',
      status: 'status: ',
      importInProgress: 'Import in progress',
      close: 'Close'
    },
    leaflets: {
      fetching: 'Загрузка скидок...',
      sorting: 'Sorting leaflets...',
      shopsUpdate:
        'Shops data are updating in background. The content of the page may be diffrent than data on the server',
      leafletsUpdate:
        'Leaflets data are updating in background. The content of the page may be diffrent than data on the server'
    },
    stores: {
      publishDate: 'Дата публикации',
      publishEndDate: 'Опубликовать до',
      naturalId: 'ID',
      seoId: 'Seo ID',
      identifiers: 'Natural ID / SEO ID',
      additionalInfo: 'Подтитул 1',
      rejectModal: 'Are you sure you want to reject this leaflet?',
      valid: 'Дата',
      platforms: 'Платформы',
      validFromPrefix: 'с',
      validToPrefix: 'до',
      status: 'Статус',
      validFrom: 'Действует от',
      validFromPlaceholder: 'Выберите дату начала действия',
      validTo: 'Действует до',
      validToPlaceholder: 'Выберите дату окончания действия',
      actions: 'Акции',
      remove: 'Удалить',
      update: 'Редактировать',
      assign: 'Assign',
      resotre: 'Restore',
      showOn: 'Видна на',
      articles: 'Товары',
      expandAllStores: 'Развернуть все магазины',
      shrinkAllStores: 'Скрыть все магазины'
    },
    syncLongUrl: {
      button: 'Синхронизировать ссылки',
      title: 'Синхронизация ссылок',
      submit: 'Синхронизировать',
      newSync: 'Новая синхронизация',
      processing: 'Обработка...',
      processingHint: 'Синхронизация может занять до минуты. Пожалуйста, подождите.',
      runDryRun: 'Запустить тест',
      dryRunComplete: 'Тест завершён',
      syncComplete: 'Синхронизация завершена',
      proceedWithSync: 'Продолжить синхронизацию',
      rerunDryRun: 'Повторить тест',
      rerunWithSameSettings: 'Повторить с теми же настройками',
      backToForm: 'Вернуться к форме',
      form: {
        sheetUrl: 'URL таблицы Google',
        sheetUrlPlaceholder: 'https://docs.google.com/spreadsheets/d/...',
        syncScope: 'Область синхронизации',
        syncAll: 'Синхронизировать все',
        syncByLeaflet: 'Синхронизировать по Natural ID каталога',
        leafletNaturalId: 'Natural ID каталога',
        leafletPlaceholder: 'Поиск каталога...',
        syncStatus: 'Статус синхронизации',
        dryRun: 'Тестовый режим (Dry Run)',
        dryRunHint: 'Симуляция без внесения изменений',
        override: 'Перезаписать существующие данные',
        overrideHint: 'Принудительно перезаписать существующие данные во время синхронизации'
      },
      syncStatus: {
        readyToSync: 'READY_TO_SYNC',
        empty: 'Без фильтра (пусто)',
        pending: 'PENDING',
        processed: 'PROCESSED',
        failed: 'FAILED',
        invalid: 'INVALID',
        unprocessable: 'UNPROCESSABLE'
      },
      validation: {
        sheetUrlRequired: 'URL таблицы Google обязателен',
        sheetUrlInvalid: 'Введите корректный URL таблицы Google',
        leafletRequired: 'Natural ID каталога обязателен'
      },
      errors: {
        syncFailed: 'Синхронизация не удалась'
      },
      result: {
        title: 'Синхронизация завершена',
        sheetUrl: 'Google Таблица',
        totalRows: 'Всего строк',
        processed: 'Обработано',
        failed: 'Неудачные',
        unprocessable: 'Необрабатываемые',
        postponed: 'Отложенные',
        superseded: 'Заменённые',
        expired: 'Истёкшие',
        rowIndex: 'Строка',
        leafletId: 'ID каталога',
        type: 'Тип',
        page: 'Страница',
        message: 'Сообщение',
        reason: 'Причина'
      }
    }
  },
  navbar: {
    logOut: 'Выйти',
    dashboard: 'Доска',
    screenfull: 'Fullscreen',
    theme: 'Theme',
    password: 'Изменить пароль',
    archives: 'Архивы',
    inserts: 'Вставки',
    logs: 'Logi',
    xmlOffers: 'Порядок Акций',
    leaflets: 'Акции',
    version: 'версия'
  },
  login: {
    title: 'Форма входа',
    logIn: 'Войти',
    username: 'Пользователь',
    password: 'Пароль'
  },
  theme: {
    change: 'Изменить стиль'
  },
  users: {
    expandedRow: {
      cooks: 'повара: ',
      stores: 'магазины: '
    },
    enable: {
      button: 'Активируй',
      success: 'Статус был изменен'
    },
    disable: {
      button: 'Дезактивируй',
      success: 'Статус был изменен'
    },
    fetchData: 'Загрузка даных..',
    id: 'ID',
    role: 'Роль',
    actions: 'Акции',
    username: 'Пользователь',
    enabled: 'Активный',
    disabled: 'Неактивный',
    assignedShops: 'Доступны магазины',
    availableShops: 'Приписаны магазины',
    availableCooks: 'Доступны повара',
    assignedCooks: 'Приписаны повара',
    availablePolicies: 'Доступные политики',
    assignedPolicies: 'Назначенные политики',
    assignAlertForAdmins: 'The administrator has access to all shops and chefs. Access management is unnecessary.',
    update: {
      title: 'Редактировать пользователя',
      button: 'Обновить',
      success: 'Пользователь был обновлен',
      error: 'Пользователь не был обновлен'
    },
    create: {
      title: 'Создать пользователя',
      username: 'Имя пользователя',
      password: 'Пароль',
      cancel: 'Отметить',
      button: 'Создать пользователя',
      success: 'Пользователь создан',
      role: 'Тип учетной записи',
      pickRole: 'Выберите роли',
      shopFilterPlaceholder: 'Search for a shop',
      cooksFilterPlaceholder: 'Search for a cook',
      policiesFilterPlaceholder: 'Поиск политики',
      notificationChannels: 'Channels',
      productPanelPolicies: 'Политики панели продуктов'
    },
    remove: {
      button: 'Удалить',
      confirm: 'Действительно хочешь удалить пользователя?',
      success: 'Пользователь был удален'
    },
    stores: 'Магазины',
    rules: {
      username: 'Имя пользователя обязательно и должно составлять более 3 знаков',
      usernameLowercase: 'Имя пользователя не должно содержать заглавные буквы',
      role: 'Тип учетной записи обязателен',
      notificationChannels: 'At least one channel is required',
      policyIds: 'Требуется хотя бы одна политика для роли PRODUCTS_VIEWER'
    },
    policyDetails: {
      title: 'Детали политики',
      brands: 'Бренды',
      categories: 'Категории',
      countries: 'Страны',
      stores: 'Магазины',
      all: 'Все',
      close: 'Закрыть'
    },
    policyManagement: {
      title: 'Управление политиками для панели продуктов',
      manageButton: 'Управление политиками для панели продуктов',
      createTitle: 'Создать новую политику',
      editTitle: 'Редактировать политику',
      createButton: 'Создать политику',
      editButton: 'Редактировать',
      deleteButton: 'Удалить',
      saveButton: 'Сохранить',
      cancelButton: 'Отмена',
      nameLabel: 'Название политики',
      namePlaceholder: 'Введите название политики',
      brandsLabel: 'Бренды',
      brandsPlaceholder: 'Выберите или создайте бренды',
      categoriesLabel: 'Категории',
      categoriesPlaceholder: 'Выберите категории',
      allCategories: 'Все категории (*)',
      countriesLabel: 'Страны',
      countriesPlaceholder: 'Выберите страны',
      storesLabel: 'Магазины',
      storesPlaceholder: 'Выберите или создайте магазины',
      deleteConfirmTitle: 'Удалить политику',
      deleteConfirmMessage: 'Вы уверены, что хотите удалить эту политику? Это действие нельзя отменить.',
      deleteConfirmButton: 'Удалить',
      createSuccess: 'Политика успешно создана',
      updateSuccess: 'Политика успешно обновлена',
      deleteSuccess: 'Политика успешно удалена',
      saveError: 'Ошибка при сохранении политики',
      deleteError: 'Ошибка при удалении политики',
      deleteConflictError: 'Невозможно удалить политику. Она назначена одному или нескольким пользователям.',
      fetchError: 'Ошибка при загрузке политик',
      validation: {
        nameRequired: 'Название политики обязательно',
        nameMinLength: 'Название политики должно содержать не менее 3 символов',
        nameMaxLength: 'Название политики не должно превышать 255 символов',
        brandsRequired: 'Требуется хотя бы один бренд',
        categoriesRequired: 'Требуется хотя бы одна категория',
        countriesRequired: 'Требуется хотя бы одна страна',
        storesRequired: 'Требуется хотя бы один магазин',
        validationFailed: 'Ошибка валидации'
      },
      countries: {
        all: 'Все (*)',
        pl: 'Польша (pl)',
        by: 'Беларусь (by)',
        cz: 'Чехия (cz)',
        lt: 'Литва (lt)',
        ro: 'Румыния (ro)',
        sk: 'Словакия (sk)',
        ua: 'Украина (ua)'
      }
    },
    changePassword: {
      button: 'Change password',
      dialogTitle: 'Change password for user {name}',
      success: 'Password changed successfully'
    },
    userCreate: {
      button: 'Добавить пользователя',
      enabled: 'Активный'
    }
  },
  groups: {
    tableLabel: {
      id: 'ID',
      name: 'Name',
      actions: 'Actions'
    },
    update: {
      button: 'Edit'
    },
    remove: {
      button: 'Delete',
      confirm: 'Do you really want to delete this group?',
      success: 'Group deleted successfully.'
    },
    addGroup: {
      title: 'Add new group',
      name: 'Name: ',
      cancelButton: 'Cancel',
      success: 'Group has been created.',
      button: 'Add group'
    },
    editGroup: {
      title: 'Edit group',
      button: 'Save changes',
      success: 'Group updated successfully.'
    }
  },
  shops: {
    unmatchedLeaflets: 'Unmatched leaflets',
    fetchData: 'Загрузка магазинов..',
    id: 'ID',
    update: 'Обновить магазин',
    editors: 'Редакторы',
    available: 'Доступны',
    add: 'Добавить магазин',
    remove: {
      button: 'Удалить',
      confirm: 'Вы действительно хотите удалить этот магазин?',
      success: 'Магазин был удален'
    },
    filterByInactive: 'Только неактивные',
    activateAllLeaflets: 'Активировать все Акции',
    showShopLeaflets: 'Развернуть Акции',
    shrinkShopLeaflets: 'Свернуть Акции',
    shopCreate: {
      title: 'Добавить магазин',
      cancel: 'Отменить',
      confirm: 'Добавить магазин',
      name: 'Название',
      storeWebId: 'Наименование Id',
      update: 'Обновить магазин',
      category: 'Категория',
      pickCategory: 'Выбрать категорию',
      salesModels: {
        label: 'Модель продаж',
        placeholder: 'Выберите модель продаж',
        options: {
          retail: 'Розничная',
          wholesale: 'Оптовая'
        }
      },
      ownBrandIds: 'ID собственных брендов',
      ownBrandIdsPlaceholder: 'Добавьте ID собственных брендов',
      success: 'Магазин был создан',
      logos: {
        title: 'Логотипы магазина',
        current: 'Текущий логотип',
        light: {
          label: 'Логотип для светлой темы',
          upload: 'Нажмите или перенесите файл, чтобы добавить светлый логотип'
        },
        dark: {
          label: 'Логотип для тёмной темы (необязательно)',
          upload: 'Нажмите или перенесите файл, чтобы добавить тёмный логотип',
          fallback: 'Если его не добавить, приложение использует логотип для светлой темы.'
        }
      },
      forceFavorites: {
        description: 'Избранный магазин',
        details: 'Shop will be shown as a Favourite to every user'
      },
      showAnyway: {
        details: 'Показать в любом случае',
        description: 'If the user hides this store, it will still be displayed in the application',
        placeholder: 'Выбрать'
      },
      storeAtFirst: {
        details: 'Показать в начале',
        description: 'Shop will be placed at the top of the list on the Stores page in the application',
        placeholder: 'Выбрать'
      },
      editors: 'Choose who should have access to the store',
      rules: {
        name: 'Название обязательно',
        storeWebId: 'Идентификатор обязателен',
        storeWebIdText: 'Идентификатор имени может состоять только из маленьких букв, цифр и знака «-»',
        storeNameDuplicate: 'The shop with the name {name} already exists',
        geolocations:
          'Каждая строка должна иметь формат lat,lng,радиус. Преобразуйте адреса с помощью волшебной палочки.',
        category: 'Категория обязательна',
        salesModels: 'Выберите хотя бы одну модель продаж'
      },
      shopUpdate: {
        title: 'Обновить магазин',
        success: 'Магазин обновлен'
      }
    },
    deleteLinks: {
      selectPlaceholder: 'Select links to delete',
      confirm: 'Do you really want to delete links from this shop?',
      success: 'Links have been removed.'
    }
  },
  password: {
    currentPassword: 'Текущий пароль',
    newPassword: 'Новый пароль',
    newPasswordRepeat: 'Повторите новый пароль',
    submitPassword: 'Изменить пароль',
    reset: 'Сбросить форму',
    rules: {
      minLength: 'Пароль обязателен и должен составлять более {minLength} знаков'
    }
  },
  leaflets: {
    addToSystem: 'Add to the system',
    dataSync: {
      message:
        'Leaflets data are updating in the background. The concent of the page may be different than data on the server.'
    },
    validation: {
      errorInLeafletId: 'в каталоге ID'
    },
    untilEndOfSupply: 'До конца запасов',
    readyForActivation: 'Каталоги готовы к публикации',
    readyForDisactivation: 'Каталоги готовы к удалению',
    fetchData: 'Загрузка акций..',
    naturalId: 'ID',
    validFrom: 'От',
    validTo: 'До',
    priority: 'Приоритет',
    refresh: {
      button: 'Refresh leaflet',
      success: 'Date has been refreshed successfully',
      confirm: 'Do you really want to refresh leaflet?'
    },
    activateStatusDate: 'Activate date',
    additionalInfo: 'Подтитул 1',
    additionalInfoMissing: '[no title]',
    additionalInfo2: 'Подтитул 2',
    longUrl: 'URL',
    thumbnailTrackingUrl: 'Thumbnail tracking URL',
    thumbnailTrackingUrlConfirm: 'You added thumbnail tracking URL (not opening leaflets)',
    redirectUrl: 'Перенаправление URL',
    status: 'Статус',
    actions: 'Акции',
    update: 'Обновить',
    add: 'Добавить газетку',
    goToPageDetails: 'Перенаправления и вставки',
    activate: 'Активировать',
    details: 'Детали',
    publishDate: 'Публикация',
    createdBy: 'Published by',
    activateReadyStatusAt: 'Refresh date',
    refreshedBy: 'Refreshed by',
    products: {
      geolocation: {
        label: 'Геолокация',
        description: 'Настройте геолокацию для каталогов этого магазина.',
        options: {
          notGeolocalized: {
            description: 'Без геолокации',
            details: 'Видна для любого местоположения'
          },
          geolocalizedDependingOnStore: {
            description: 'По местоположению магазина',
            details: 'Видна рядом с магазином'
          },
          geolocalizedDependingOnAreas: {
            description: 'По заданным областям',
            details: 'Видна в пределах заданных областей'
          }
        },
        showToUserWithNoLocation: {
          description: 'Показывать пользователям без местоположения',
          details: 'Каталог будет виден пользователям, которые не указали местоположение'
        },
        areas: {
          label: 'Список областей (lat/lng/rad)',
          description:
            'Введите каждый адрес или область с новой строки. Используйте волшебную палочку для преобразования адресов. Радиус указывается в метрах.',
          placeholder: 'Варшава\n51.4141,16.55551,100'
        },
        availableAreas: {
          label: 'Области показа (lat/lng/rad)',
          description:
            'Каталог будет виден в этих областях. Введите каждый адрес или область с новой строки. Радиус указывается в метрах.',
          placeholder: 'Варшава\n51.4141,16.55551,100'
        },
        unavailableAreas: {
          label: 'Исключённые области (lat/lng/rad)',
          description:
            'Каталог не будет виден в этих областях. Введите каждый адрес или область с новой строки. Радиус указывается в метрах.',
          placeholder: 'Краков\n50.0647,19.945,500'
        },
        geocode: {
          tooltip: 'Преобразовать адреса в координаты',
          ariaLabel: 'Преобразовать введённые адреса',
          success: 'Преобразовано адресов: {count}',
          partialSuccess: 'Преобразовано адресов: {converted}. Не распознано: {failed}.',
          failure: 'Не удалось распознать адреса: {count}.'
        },
        map: {
          ariaLabel: 'Предварительный просмотр областей геолокации на карте',
          empty: 'Карта появится после ввода координат или преобразования адреса.',
          legend: {
            ariaLabel: 'Легенда доступности областей',
            available: 'Показывать',
            unavailable: 'Скрыть'
          }
        }
      },
      button: 'Products',
      fetchError: 'Ошибка при загрузке данных о продуктах',
      count: 'products',
      brandLabel: 'Brand',
      manufacturerLabel: 'Производитель',
      manufacturerSourceLabel: 'Источник информации',
      manufacturerSources: {
        printed: 'Каталог',
        package: 'Упаковка',
        knowledge: 'Знания'
      },
      validation: {
        manufacturerRequired: 'Укажите производителя для выбранного источника',
        manufacturerSourceRequired: 'Выберите источник информации о производителе'
      },
      variantLabel: 'Вариант',
      packagingLabel: 'Packaging',
      packagingTypeLabel: 'Тип упаковки',
      packagingSubtypeLabel: 'Подтип упаковки',
      packCountLabel: 'Количество в упаковке',
      unitSizeLabel: 'Размер единицы',
      coordsLabel: 'Coords',
      priceLabel: 'Price',
      mapPriceLabel: 'Map price',
      crossedPriceLabel: 'Crossed price',
      pricePerUnitLabel: 'Price per unit',
      pricePerUnitBasisLabel: 'Основа цены за единицу',
      unitLabel: 'Unit',
      discountLabel: 'Скидка',
      lowestPrice30DaysLabel: 'Минимальная цена за 30 дней',
      depositLabel: 'Залог',
      multibuyLabel: 'Покупка нескольких товаров',
      multibuyTypeLabel: 'Тип мультипокупки',
      multibuyTextLabel: 'Условия мультипокупки',
      sizeOptionsLabel: 'Варианты размера',
      specsTextLabel: 'Характеристики',
      soldByLabel: 'Способ продажи',
      loyaltyProgramLabel: 'Программа лояльности',
      conditionTextLabel: 'Условия предложения',
      minQtyLabel: 'Минимальное количество',
      limitLabel: 'Лимит покупки',
      blockCountLabel: 'Количество рекламных блоков',
      reviewReasonsLabel: 'Причины для проверки',
      addSizeOption: 'Добавить вариант размера',
      removeSizeOption: 'Удалить вариант размера',
      noSizeOptions: 'Нет вариантов размера',
      sections: {
        basic: 'Основные данные',
        pricing: 'Цены и акции',
        packaging: 'Упаковка и продажа',
        conditions: 'Условия предложения',
        quality: 'Контроль качества'
      },
      keywordsLabel: 'Keywords',
      keywordsPlaceholder: 'Enter keyword',
      categoriesRemovedOnSave: 'Сохранение предложения удалит неактивные и неизвестные категории: {names}',
      addKeyword: 'Add keyword',
      createKeywordConfirmTitle: 'Create new keyword',
      createKeywordConfirmMessage: 'Do you want to create the new keyword “{keyword}”?',
      createKeywordSuccess: 'The new keyword has been created',
      createKeywordError: 'Failed to create the new keyword',
      keywordsFetchError: 'Failed to fetch active keywords',
      invalidKeyword: 'A keyword must contain between 1 and 100 characters',
      multipleKeywordsUnsupported: 'Add new keywords one at a time',
      ownBrandLabel: 'Own Brand',
      promotedLabel: 'Promoted',
      flagEnabled: 'True',
      flagDisabled: 'False',
      categoryLabel: 'Category',
      title: 'Article data',
      duplicate: 'Дублировать',
      roboflow: {
        addToTraining: 'Отправить для обучения',
        addSuccess: 'Страница {pageNumber} добавлена в очередь обучающих данных.',
        addError: 'Не удалось добавить страницу в очередь обучающих данных.'
      },
      recutPage: {
        button: 'Повторить вырезку страницы',
        confirmTitle: 'Повторить вырезку страницы?',
        confirmMessage:
          'Повторная вырезка страницы {pageNumber} может заменить находящиеся на ней товары и ручные правки.',
        confirmButton: 'Повторить вырезку страницы',
        success: 'Запрос на повторную вырезку страницы {pageNumber} отправлен.',
        error: 'Не удалось повторить вырезку страницы {pageNumber}.'
      }
    },
    remove: {
      button: 'Удалить',
      confirm: 'Вы действительно хотите удалить этот каталог?',
      success: 'Каталог удален'
    },
    openPageDetailsImages: 'Предварительный просмотр страниц',
    zipCodes: 'Почтовый индекс',
    pageCount: 'Страницы',
    statusList: {
      INACTIVE: 'Не активная',
      READY_FOR_ACTIVATION: 'Готова к активации',
      ACTIVE: 'Активная',
      READY_FOR_DISACTIVATION: 'Готова к дезактивации',
      DELETED: 'Deleted'
    },
    pageDetailsImages: {
      title: 'Предварительный просмотр фото каталога',
      pageNumber: 'Номер страницы',
      dimensions: 'Измерение',
      size: 'Размер'
    },
    organizePages: {
      title: 'Организовать Страницы',
      description: 'Просматривайте и организуйте страницы этого каталога. Страницы отображаются в текущем порядке.',
      downloadInfo:
        'Чтобы загрузить страницы в другом порядке, скачайте все изображения, а затем загрузите их во вкладке "Загрузить новый каталог".',
      pageNumber: 'Страница {number}',
      pagePreview: 'Предварительный просмотр страницы {number}',
      noPages: 'Страницы для этого каталога не найдены',
      noLeafletId: 'ID каталога не предоставлен',
      fetchError: 'Не удалось получить детали страниц',
      error: 'Ошибка при загрузке страниц'
    },
    uploadWrapper: {
      uploadNewLeaflet: 'Загрузить новый каталог',
      organizePages: 'Организовать страницы'
    },
    rules: {
      naturalId: 'Уникальное название обязательно',
      validFrom: 'Дата „от” обязательна',
      validTo: 'Дата „до” обязательна',
      validToExpired: 'The expiry date has already passed. Make sure you enter the correct date.',
      validToBeforeValidFrom: 'Дата окончания не может быть раньше даты начала',
      publishDateIsFromThePast: 'Publish date cannot be from the past',
      publishDate: 'Дата публикации обязательна',
      active: 'Статус акции обязателен',
      file: 'Обязателен хотяб один файл',
      priority: 'Позиция должна быть натуральным числом',
      numberOfImages: 'Number of images быть натуральным числом',
      geolocations:
        'Каждая строка должна иметь формат lat,lng,радиус. Преобразуйте адреса с помощью волшебной палочки.',
      socialMediaUrl: 'Пожалуйста, укажите действительный URL'
    },
    uploadFiles: {
      select: 'Для загрузки файла нажмите или перенесите сюда файл',
      send: 'Выслать',
      wrongFile: 'Неверный формат файла',
      tooManyPdfs: 'Можешь добавить только один файл PDF',
      wrongId: 'Вы действительно хотите добавить PDF с названием Id, кроме',
      firstPage: 'Нажмите или перенесите файл чтобы изменить обложку',
      outdatedPdf:
        'The dates defined in the pdf file are in the past. Name the file correctly or enter the correct dates.'
    },
    leafletsCreate: {
      title: 'Добавить каталог',
      naturalId: 'ID',
      validFrom: {
        label: 'От',
        placeholder: 'Введите дату'
      },
      group: 'Group',
      newGroup: 'New',
      additionalOptions: 'Additional options',
      hasRecipe: 'Has recipe',
      category: {
        label: 'Set category',
        placeholder: 'Default'
      },
      publishDate: {
        label: 'Публикация',
        placeholder: 'Выберите дату'
      },
      publishEndDate: {
        label: 'Publish until',
        placeholder: 'Выберите дату'
      },
      validTo: {
        label: 'До',
        placeholder: 'Введите дату',
        checkbox: 'До окончания товара'
      },
      showOn: {
        label: 'Видна на',
        android: 'Android',
        androidMG: 'Moja Gazetka (Android)',
        androidMP: 'mPromocje (Android2)',
        iOS: 'iOS',
        ios: 'iOS',
        web: 'Web',
        wp: 'WP',
        android2: {
          'dev-1-pl': 'mPromocje',
          'dev-1-ua': 'Love Sales Light',
          'preprod-pl': 'mPromocje',
          'preprod-ua': 'Love Sales Light',
          'local': 'mPromocje',
          'pl': 'mPromocje',
          'ua': 'Love Sales Light'
        }
      },
      leaflet: 'Каталог',
      pdfURL: 'Ссылка на PDF файл',
      imagesURLPattern: 'Link pattern',
      numberOfImages: 'Links amount',
      advanced: 'Расширенные',
      lastPageInsert: 'Создать вставку «Оценить»',
      adultsOnly: {
        label: 'Каталог для взрослых',
        hint: 'Каталог для взрослых виден только в {platform}',
        hintNoPlatform: 'Каталог для взрослых не виден ни на одной платформе',
        badge: 'Только 18+'
      },
      showOnlineBadge: 'Show online badge',
      showPopularBadge: 'Show popular badge',
      addWatermark: 'Add watermark',
      previewFilesShow: 'Показать {number} файлов',
      hideFilesShow: 'Скрыть {number} файлов',
      notAllowShoppingList: 'Выключить список покупок',
      notShowAdInserts: 'Выключить вставки',
      forceLast: 'Put at the end of the list',
      redirectUrl: 'Перенаправление URL',
      zipCodes: 'Почтовый индекс',
      additionalInfo: 'Подтитул 1',
      additionalInfo2: 'Подтитул 2',
      socialMedia: {
        label: 'Социальные сети',
        youtube: 'YouTube URL',
        youtubePlaceholder: 'https://www.youtube.com/watch?v=...',
        platform: 'Платформа',
        url: 'URL',
        addNewLink: 'Добавить новую ссылку',
        remove: 'Удалить',
        duplicateUrl: 'Этот URL уже добавлен',
        tiktok: 'TikTok URL',
        tiktokPlaceholder: 'https://www.tiktok.com/...'
      },
      replaceValidity: {
        text: 'Replace validity text',
        isNull: 'No changes',
        isEmpty: 'Empty'
      },
      longUrl: 'Подсчет URL',
      thumbnailTrackingUrl: 'Thumbnail tracking URL',
      status: {
        label: 'Статус'
      },
      confirm: 'Создать',
      success: 'Акция создана',
      multipleLeafletsSuccess: 'Количество созданных акций: {number}',
      multipleLeafletsFailure: 'Не получилось создать некоторые акции',
      uploadingFiles: 'Загрузка файлов...',
      generatingImages: 'Генерация изображений...',
      generationTimeout: 'Генерация изображений занимает слишком много времени',
      generationFailed: 'Не удалось сгенерировать изображения',
      invalidTabs: 'Некоторые вкладки содержат неверные или отсутствующие данные',
      error: 'Акция не была создана',
      update: 'Обновить',
      cancel: 'Отменить',
      invalidTab: 'Неправильный',
      priorityLabels: {
        android: 'Android позиция',
        ios: 'IOS позиция',
        web: 'Web позиция',
        wp: 'WP позиция',
        all: 'Show on all platforms',
        android2: {
          'dev-1': 'mPromocje позиция',
          'preprod': 'mPromocje позиция',
          'preprod-pl': 'mPromocje позиция',
          'preprod-ua': 'Love Sales Light позиция',
          'local': 'mPromocje позиция',
          'pl': 'mPromocje позиция',
          'ua': 'Love Sales Light позиция'
        }
      }
    },
    leafletsUpdate: {
      title: 'Редактировать каталог',
      success: 'Каталог отредактирован',
      error: 'Каталог не был обновлен',
      overwritePriority:
        'Позиция {priorityNumber} уже установлена для акции с id: {leafletId}. Хотите изменить позицию?',
      overwritePriorities:
        'На {leafletsCount} платформах данной Акции уже есть другая Акция с позицией  {priorityNumber}. Хотите изменить позиции Акций?',
      coverUpdated: 'Обложка Акции обновлена'
    }
  },

  leafletPageDetails: {
    sharedDialogs: {
      pageCount: 'Количество страниц: {numberOfPages}',
      cancel: 'Отменить',
      positionNumber: 'Номер позиции',
      positionNumbers: 'Номера позиций',
      description: 'Отображаемое описание',
      longUrl: 'Подсчет URL',
      redirectUrl: 'Перенаправление URL',
      infoAlert:
        'The position numbers should be entered after a comma (eg. 1, 2, 3, 7) or a range should be given (eg. 5 - 12)',
      rules: {
        pageNumbersRequired: 'Номер позиции обязателен',
        removeDuplicate: 'Удалить дублированные позиции',
        haveZero: 'Позиция не может быть нулевой',
        allFieldsRequired: 'All fields are required',
        oneOfFieldsRequired: 'One of the fields must be completed',
        dateFromPast: 'Backdated link replacement cannot be scheduled',
        platformIsRequired: 'At least one platform have to be selected'
      }
    },
    insertDialog: {
      addTitle: 'Добавить вставку в {naturalId}',
      editTitle: 'Обновить вставку в {naturalId}',
      addConfirm: 'Добавить',
      editConfirm: 'Добавить',
      creationSuccess: 'Вставка была создана',
      updateSuccess: 'Вставка были перезаписаны',
      overrideConfirm: 'Вставка уже существует в этой позиции. Вы уверены, что хотите перезаписать ее?',
      insertId: {
        label: 'ID',
        placeholder: 'Выбрать'
      },
      infoAlert:
        'The position numbers should be entered after a comma (eg. 1, 2, 3, 7) or a range should be given (eg. 5 - 12)',
      rules: {
        insertIdRequired: 'ID вставки обязателен',
        valueOutOfRange: 'Данная позиция больше чем количество страниц каталога + 1'
      }
    },
    redirectDialog: {
      addTitle: 'добавить перенаправление на {naturalId}',
      editTitle: 'обновить перенаправление в {naturalId}',
      allPages: 'добавить ссылки на все страницы',
      addConfirm: 'Добавить перенаправление',
      editConfirm: 'Обновить перенаправление',
      creationSuccess: 'Перенаправление успешно создано',
      updateSuccess: 'Перенаправление было перезаписано',
      schedule: {
        redirectUrl: 'Set redirect URL',
        thumbnailTrackingUrl: 'Set thumbnail tracking URL',
        longUrl: 'Set long URL',
        toDay: 'to',
        selectDay: 'select the day',
        atHour: 'at',
        selectHour: 'select the hour',
        changeTo: 'change to',
        typeNewLink: 'type new link'
      },
      scheduledEvents: {
        planningSuccess: 'Link swaps have been scheduled',
        redirectDeletionSuccess: 'Redirect link swap has been deleted.',
        longDeletionSuccess: 'Long link swap has been deleted.',
        thumbnailTrackingDeletionSuccess: 'Thumbnail tracking link swap has been deleted.',
        deleteLongButton: 'Delete scheduled long link swap',
        deleteRedirectButton: 'Delete scheduled redirect link swap'
      },
      overrideConfirm: 'На этой странице уже есть перенаправление. Вы уверены, что хотите перезаписать его?',
      rules: {
        valueOutOfRange: 'Данная позиция больше чем количество страниц каталога'
      }
    }
  },
  pageDetails: {
    fetchData: 'Загрузка деталей страниц..',
    description: 'Описание',
    insertImageURL: 'URL фото',
    insertName: 'Название',
    pageNumber: 'Номер страницы',
    positionNumber: 'Номер позиции',
    redirectURL: 'Перенаправление URL',
    scheduledLinkReplacement: 'Scheduled link replacement',
    links: 'Ссылки',
    date: 'Date',
    platforms: 'Platforms',
    longUrl: 'URL',
    actions: 'Акции',
    insertsFor: 'Вставки и перенаправления для каталога:',
    showOnlineBadgeUpdate: {
      trueMsg: 'Leaflet checked as online',
      falseMsg: 'Deselected online status for the leaflet'
    },
    leafletLinks: {
      longUrl: 'URL отслеживания каталога',
      thumbnailTrackingUrl: 'URL отслеживания миниатюр каталога',
      edit: 'Edit',
      sync: 'Sync links',
      empty: '—',
      dialogTitle: 'Edit leaflet links',
      saveSuccess: 'Leaflet links saved successfully',
      saveError: 'Failed to save leaflet links'
    },
    inserts: 'Вставки',
    redirects: 'Перенаправления',
    removeInsert: {
      button: 'Удалить',
      confirm: 'Действительно удалить вставку с этой страницы?',
      success: 'Вставка была удалена'
    },
    removeRedirect: {
      button: 'Удалить',
      // confirm: 'Действительно удалить перенаправление с этой страницы?',
      confirm: 'Do you really want to remove links from this page?',
      success: 'Перенаправление было удалено'
    },
    removeAllRedirects: {
      button: 'Delete all links',
      confirm: 'Do you really want to remove all links from this leaflet?',
      success: 'Links removed successfully.'
    },
    linkCreate: {
      button: 'Add links',
      title: 'Add links to '
    },
    bulkLinkCreate: {
      button: 'Bulk add links',
      title: 'Bulk add links to',
      dialog: {
        descriptionLabel: 'Description:',
        linksLabel: 'Links:',
        linksPlaceholder: 'Paste data from text editor here',
        addLinksBtn: 'Add links',
        cancelBtn: 'Отменить'
      }
    },
    insertUpdate: {
      button: 'Обновить'
    },
    insertCreate: {
      button: 'Добавить вставку'
    },
    insertDeleteAll: {
      button: 'удалить все вставку',
      confirm: 'Are you sure you want to delete all leaflet inserts?',
      success: 'All inserts were successfully removed from the leaflet'
    },
    leafletArea: {
      areasDefinition: 'Define areas',
      page: 'Page: ',
      dimensions: 'Dimensions',
      areas: 'areas',
      link: 'Link',
      save: 'Save',
      promotedProduct: 'Promoted product',
      promoted: 'Promoted',
      pageArea: 'Page areas',
      deleteAll: 'Delete all',
      color: 'Color',
      actions: 'Actions',
      cancel: 'Cancel',
      deleteArea: {
        confirm: 'Do you really want to delete area?',
        successMsg: 'Area deleted successfully.'
      },
      deleteAllAreas: {
        confirm: 'Do you really want to delete ALL areas?',
        successMsg: 'All areas on {page} page deleted successfully.'
      },
      affiliation: {
        selectPlaceholder: 'No affiliation'
      },
      linkRequired: 'Link is required',
      linkInvalid: 'Link is invalid',
      areaInvalid: 'Selected area is invalid, should be at least 5 x 5 px',
      loadLinksFromPDF: {
        uploadButton: 'Load links from PDF file',
        uploadButtonPending: 'Loading links from PDF file...',
        successMsg: 'Links from file are loaded',
        errorMsg: 'Loading links has failed',
        progressMsg: 'Loading links from PDF is in progress...'
      }
    }
  },
  newLeafletsSearch: {
    fetching: 'Loading data...',
    noStoreSelected: 'Please select a store to view leaflets',
    noStoreSelectedDescription: 'Choose a store from the dropdown above to see available leaflets',
    id: 'ID',
    status: 'Status',
    storeName: 'Store name',
    title: 'Title',
    validFrom: 'Valid from',
    validTo: 'Valid to',
    numberOfPages: 'Number of pages',
    url: 'Identified by',
    attachments: 'Attachments',
    actions: 'Actions',
    updatedAt: 'Last updated',
    runCrawler: {
      button: 'Run crawler again',
      running: 'Crawling in progress',
      success: 'Crawling started successfully',
      error: 'Error during crawling'
    }
  },
  inserts: {
    fetchData: 'Загрузка вставок..',
    add: 'Добавить вставки',
    description: 'Отображаемое описание',
    redirectUrl: 'Перенаправление URL',
    showOn: 'Видна на',
    insertName: 'название',
    insertImage: 'фото',
    actions: 'Акции',
    searchPlaceholder: 'Поиск вставок по названию',
    showUsed: 'Показать используемые вставки',
    clearSearch: 'Очистить поиск',
    noData: 'Нет вставок',
    noDataFound: 'Нет вставок, найденных по этому запросу',
    details: {
      deletion: {
        button: 'Remove insert from leaflet | Remove insert from leaflets',
        success: 'Вставка удалена из всех каталогов',
        failed: 'Не удалось удалить вставку из некоторых каталогов. Попробуйте ещё раз.'
      },
      removeAllLeafletsTitle: 'Удалить все связи',
      removeAllLeafletsDescription:
        'Вы уверены, что хотите удалить эту вставку из всех каталогов, к которым она привязана?',
      empty: 'Нет каталогов для отображения',
      fetch: {
        error: {
          title: 'Ошибка загрузки каталогов',
          description: 'Не удалось получить данные каталогов. Попробуйте ещё раз.'
        },
        partialError: {
          title: 'Некоторые каталоги не удалось загрузить',
          description: 'Некоторые каталоги не загружены, но остальные отображены ниже.'
        }
      }
    },
    upload: {
      success: 'Вставка отправлена',
      failure: 'Вставка не отправлена'
    },
    update: {
      title: 'Редактировать вставку',
      button: 'Обновить',
      success: 'Вставка отрудактирована'
    },
    remove: {
      button: 'Удалить',
      confirm: 'Вы действительно хотите удалить эту вставку?',
      success: 'Вставка удалена',
      failure: 'Вставка используется в каталогах:'
    },
    archive: {
      button: 'Архивировать',
      confirm: 'Вы действительно хотите архивировать эту вставку?',
      success: 'Вставка архивирована'
    },
    geolocation: {
      label: 'Геолокация',
      enabled: {
        description: 'Геолокация по областям',
        details: 'Вставка будет отображаться в соответствии с настроенными областями'
      },
      availableAreas: {
        label: 'Области отображения (lat/lng/rad)',
        description:
          'Вставка будет отображаться в этих областях. Введите каждый адрес или область с новой строки. Радиус указывается в метрах.',
        placeholder: 'Варшава\n51.4141,16.55551,100'
      },
      unavailableAreas: {
        label: 'Исключённые области (lat/lng/rad)',
        description:
          'Вставка не будет отображаться в этих областях. Введите каждый адрес или область с новой строки. Радиус указывается в метрах.',
        placeholder: 'Краков\n50.0647,19.945,500'
      }
    },
    insertCreate: {
      title: 'Добавить вставку',
      description: 'Отображаемое описание',
      redirectUrl: 'Перенаправление URL',
      longUrl: 'Подсчет URL',
      insertName: 'Техническое название',
      insertImageUrl: 'URL фото',
      showOnIOS: 'Показать на IOS',
      showOnAndroid: 'Показать на Android',
      showOnAndroid2: {
        'dev-1': 'Показать на mPromocje',
        'dev-1-pl': 'Показать на mPromocje',
        'preprod': 'Показать на mPromocje',
        'preprod-pl': 'Показать на mPromocje',
        'pl': 'Показать на mPromocje',
        'ua': 'Показать на Love Sales Light'
      },
      insertImage: 'Drop file here or click to upload insert photo',
      showOnWeb: 'Показать на web',
      confirm: 'Создать',
      update: 'Обновить',
      cancel: 'Отменить',
      select: 'Выбрать фото',
      success: 'Вставка создана'
    },
    rules: {
      name: 'Название обязательно',
      image: 'Фото обязательно',
      existing: 'Insert with given name exists',
      geolocations: 'Каждая строка должна иметь формат lat,lng,радиус. Преобразуйте адреса с помощью волшебной палочки.'
    }
  },
  productHits: {
    boost: {
      title: 'Продвижение товара',
      promote: 'Продвигать',
      cancel: 'Отменить продвижение',
      position: 'Целевая позиция',
      until: 'Окончание продвижения',
      startsNow: 'Продвижение начинается сразу. Время указано в часовом поясе браузера.',
      validation: 'Укажите положительную целую позицию и дату окончания в будущем.',
      success: 'Товар продвигается',
      error: 'Не удалось изменить продвижение. Повторите попытку.',
      conflict: 'У товара уже есть продвижение. Запрошено обновление рейтинга.',
      forbidden: 'У вас нет прав на управление продвижением.',
      cancelConfirm: 'Отменить продвижение? Товар вернётся на органическую позицию.',
      cancelSuccess: 'Продвижение отменено',
      notFound: 'Это продвижение уже не существует.',
      refreshError: 'Не удалось обновить рейтинг. Повторите загрузку, чтобы увидеть актуальные позиции.'
    },
    title: 'Хиты продуктов',
    promoted: 'Продвигаемый',
    add: 'Добавить продукт',
    fetchData: 'Загрузка хитов продуктов...',
    table: {
      no: '#',
      trend: 'Тренд',
      product: 'Продукт',
      priceBefore: 'До',
      priceAfter: 'После',
      validity: 'Действует',
      promotion: 'Акция',
      shop: 'Магазин',
      actions: 'Действия'
    },
    actions: {
      edit: 'Редактировать',
      delete: 'Удалить',
      refresh: 'Обновить',
      deleteConfirmTitle: 'Удалить продукт',
      deleteConfirmMessage: 'Вы уверены, что хотите удалить этот продукт?',
      deleteSuccess: 'Продукт удалён',
      deleteError: 'Не удалось удалить продукт'
    },
    details: {
      title: 'Детали продукта',
      name: 'Название',
      brand: 'Марка',
      trendIndex: 'Индекс тренда',
      addedToShoppingList: 'Добавлено в список покупок',
      mainInfo: 'Основная информация',
      position: 'Позиция',
      priceBefore: 'до{currencySuffix}',
      priceAfter: 'после{currencySuffix}',
      promotion: 'Акция',
      validity: 'Действует',
      validFrom: 'Действует с',
      validTo: 'Действует до',
      shop: 'Магазин',
      redirectUrl: 'Переадресация',
      productFromLeaflet: 'Продукт из акции',
      editButton: 'Редактировать продукт',
      deleteButton: 'Удалить продукт',
      positionEdit: {
        confirm: 'Подтвердить позицию',
        cancel: 'Отменить редактирование',
        success: 'Позиция обновлена',
        error: 'Не удалось обновить позицию',
        validationError: 'Позиция должна быть целым числом не менее 1'
      }
    },
    form: {
      title: 'Добавить продукт',
      editTitle: 'Редактировать продукт',
      label: 'Название',
      brand: 'Марка',
      tiValue: 'Индекс тренда',
      crossedPrice: 'Цена до',
      currentPrice: 'Цена после',
      mainInfo: 'Основная информация',
      discount: 'Акция',
      validFrom: 'Действует с',
      validTo: 'Действует до',
      storeName: 'Магазин',
      redirectUrl: 'Переадресация',
      isPromotedDescription: 'Продвигаемое предложение',
      isPromotedDetails: 'Должен ли продукт иметь метку "Спонсировано"',

      uploadProduct: 'Нажмите или перетащите файл для загрузки фото продукта',
      uploadProductReplace: 'Нажмите или перетащите файл для замены фото продукта',
      uploadStoreLogo: 'Нажмите или перетащите файл для загрузки логотипа магазина',
      uploadStoreLogoReplace: 'Нажмите или перетащите файл для замены логотипа магазина',
      productImagePreviewAlt: 'Предпросмотр фото продукта',
      storeLogoPreviewAlt: 'Предпросмотр логотипа магазина',
      createSuccess: 'Продукт добавлен',
      createError: 'Не удалось добавить продукт',
      editSuccess: 'Продукт обновлён',
      editError: 'Не удалось обновить продукт',
      rules: {
        label: 'Название обязательно',
        tiValue: 'Индекс тренда обязателен',
        crossedPriceRequiresCurrentPrice: 'Цена до требует цены после',
        priceOrMainInfo: 'Укажите цену после или основную информацию',
        mainInfoMaxLength: 'Основная информация может содержать не более {max} символов',
        validFrom: 'Дата с обязательна',
        validTo: 'Дата до обязательна',
        productImage: 'Фото продукта обязательно',
        storeName: 'Название магазина обязательно'
      }
    }
  },
  logs: {
    pickFile: 'Выбрать файл',
    downloadFile: 'Скачать действия в системе'
  },
  xmls: {
    pickDevice: 'Выбрать тип устройства'
  },
  productCategories: {
    loading: 'Загрузка категорий товаров...',
    loadError: 'Не удалось загрузить категории товаров.',
    code: 'Код',
    name: 'Название',
    sortOrder: 'Порядок',
    status: 'Статус',
    active: 'Активна',
    inactive: 'Неактивна',
    updatedAt: 'Последнее изменение',
    actions: 'Действия',
    activate: 'Активировать',
    deactivate: 'Деактивировать',
    activated: 'Категория активирована.',
    deactivated: 'Категория деактивирована.',
    addCategory: 'Добавить категорию',
    addSubcategory: 'Добавить подкатегорию',
    edit: 'Редактировать',
    form: {
      createTitle: 'Добавить категорию товара',
      codeImmutable: 'Код нельзя изменить после создания категории.',
      parent: 'Родитель',
      parentPlaceholder: 'Нет (корневая категория)',
      sortOrderHint: 'Оставьте пустым, чтобы разместить в конце.',
      cancel: 'Отмена',
      create: 'Добавить',
      createSuccess: 'Категория товара добавлена.',
      editTitle: 'Редактировать категорию товара',
      save: 'Сохранить',
      editSuccess: 'Категория товара сохранена.',
      renameConfirm: {
        title: 'Переименовать категорию?',
        message:
          'Предложения и политики, привязанные к «{from}», потеряют эту категорию, так как ссылаются на категории по названию. Переименовать в «{to}»?',
        confirm: 'Переименовать'
      },
      errors: {
        code: {
          required: 'Введите код.',
          tooLong: 'Код может содержать не более 200 символов.',
          invalidFormat: 'Используйте строчные буквы, цифры, «.», «_» и «-», начиная с буквы или цифры.'
        },
        name: {
          required: 'Введите название.',
          tooLong: 'Название может содержать не более 255 символов.'
        }
      }
    },
    nameStatus: {
      inactive: 'неактивная',
      unknown: 'неизвестная'
    },
    errors: {
      accessDenied: 'Нет доступа к категориям товаров.',
      hasChildren: 'У категории есть активные подкатегории. Сначала деактивируйте её подкатегории.',
      codeAlreadyExists: 'Категория с таким кодом уже существует.',
      nameAlreadyExists: 'Категория с таким названием уже существует у этого родителя.',
      invalidCode: 'Недопустимый код.',
      parentNotFound: 'Родительская категория больше не существует. Обновите страницу и повторите попытку.',
      cycle: 'Нельзя переместить категорию в неё саму или в её подкатегорию.',
      notFound: 'Категория больше не существует. Обновите страницу и повторите попытку.',
      unknown: 'Непредвиденная ошибка. Повторите попытку позже.'
    }
  },
  categories: {
    fetchData: 'Загрузка категорий...',
    logo: 'Logo',
    id: 'ID',
    name: 'Название',
    categoryWebId: 'Название Id',
    update: {
      title: 'Редактировать категорию',
      button: 'Редактировать',
      success: 'Категория обновлена'
    },
    create: {
      title: 'Создать категорию',
      button: 'Добавить категорию',
      success: 'Категория создана'
    },
    rules: {
      name: 'Название категории обязательно',
      categoryWebId: 'Название Id обязательно'
    },
    logoUpload: 'Нажмите или перенесите файл чтобы добавить Логотип',
    updateConfirm: 'Редактировать',
    createConfirm: 'Добавить',
    cancel: 'Отменить',
    actions: 'Акции',
    remove: {
      button: 'Удалить',
      confirm: 'Вы действительно хотите удалить эту категорию?',
      success: 'Категория удалена'
    }
  },
  archives: {
    inserts: {
      restore: 'Восстановить',
      restoreConfirm: 'Вы действительно хотите восстановить эту вставку?',
      restoreSuccess: 'Вставка восстановлена успешно',
      restoreError: 'Ошибка при восстановлении вставки',
      clearSearch: 'Очистить поиск',
      noData: 'Нет вставок',
      noDataFound: 'Нет вставок, найденных по этому запросу'
    },
    selectType: 'Выберите тип архивов, которые хотите увидеть',
    placeholder: 'Выбрать',
    navButtons: {
      leaflets: 'Каталоги',
      shops: 'Stores',
      notifications: 'Уведомления',
      leafletDetails: 'Leaflet details'
    },
    leaflets: {
      restore: 'Restore',
      viewDetails: 'Посмотреть детали',
      leafletsCount: 'каталогов',
      pickDate: 'Pick date',
      filters: {
        title: 'Filters',
        storeName: 'Store name:',
        subtitle: 'Subtitle:',
        validDates: 'Даты действия:',
        searchButton: 'Search',
        clearButton: 'Clear',
        validFrom: 'Valid from:',
        validTo: 'Valid to:',
        sortBy: 'Sort by:',
        noData: 'No data to display',
        pressSearchButton: "Press 'Search' button to display data"
      },
      sortOptions: {
        id: 'Store id',
        name: 'Store name',
        category: 'Category',
        storeWebId: 'Store web id',
        logoUrl: 'Logo URL',
        showAnyway: 'Show anyway',
        storeAtFirst: 'Store at first',
        ascend: 'По возрастанию',
        descend: 'По убыванию',
        order: 'Порядок'
      },
      selectOptions: {
        true: 'True',
        false: 'False'
      }
    },
    notifications: {
      title: 'Уведомления',
      filters: {
        title: 'Фильтры и сортировка'
      },
      tableLabels: {
        device: 'Устройство',
        id: 'Id',
        notificationId: 'ID уведомления',
        responseCode: 'Код ответа',
        sentAt: 'Отправлено',
        stores: 'Магазины',
        channel: 'Канал',
        details: 'Детали'
      },
      sortOptions: {
        device: 'Устройство',
        id: 'ID',
        notificationId: 'ID уведомления',
        responseCode: 'Код ответа',
        sentAt: 'Дата отправки',
        stores: 'Магазины'
      }
    },
    leafletDetails: {
      additionalInfo: 'Additional info: ',
      naturalId: 'Natural ID: ',
      seoId: 'SEO ID: ',
      status: 'Status: ',
      platforms: 'Publication platforms: ',
      validFrom: 'Valid from ',
      validTo: ' to ',
      publishDate: 'Publish date: ',
      createdAt: 'Created at: ',
      numberOfPages: 'Number of pages: ',
      showAdInserts: 'Show inserts: ',
      zipCode: 'Zip codes: ',
      longURL: 'URL: ',
      thumbnailTrackingUrl: 'Thumbnail tracking URL: ',
      redirectURL: 'Redirect URL: ',
      searchLabel: 'Insert leaflet natural ID',
      searchPlacecholder: 'Leaflet natural ID',
      closeCard: 'Close card',
      createdBy: 'Published by: ',
      activateReadyStatusAt: 'Refresh date: ',
      refreshedBy: 'Refreshed by: '
    },
    leafletUpdateHistory: {
      title: 'Edition history',
      leafletHistoryTab: 'Leaflet history',
      pageDetailsHistoryTab: 'Inserts history',
      redirectsHistoryTab: 'Redirects history',
      description: 'Description',
      actionType: 'Action type',
      field: 'Field',
      oldValue: 'Previous value',
      newValue: 'New value',
      pageNumber: 'Position number',
      visibleAt: 'Visible at',
      insertName: 'Name',
      modifiedBy: 'Edited by',
      modifiedAt: 'Edited at',
      added: 'Added',
      deleted: 'Deleted',
      redirects: {
        description: 'Description',
        pageNumber: 'Page number',
        redirectURL: 'Redirect URL',
        longUrl: 'Подсчет URL'
      },
      android: 'Android',
      ios: 'IOS',
      longUrlVisibleAt: 'Long URL for',
      redirectUrl: 'Redirect URL',
      longUrl: 'Подсчет URL',
      previousValue: 'Previous value: '
    },
    shops: {
      noArchivedShops: 'Нет архивированных магазинов',
      archived: 'Архивирован'
    },
    restore: {
      title: 'Подтвердите восстановление',
      button: 'Восстановить',
      confirm: 'Вы действительно хотите восстановить этот магазин?',
      success: 'Магазин успешно восстановлен'
    }
  },
  showHttpWarning: 'New versions of iOS and Android cannot open links without SSL!',
  cooksAndRecipes: {
    recipeTable: {
      title: 'Title',
      type: 'Type',
      visibleAt: 'Visible at',
      status: {
        label: 'Status'
      },
      actions: {
        label: 'Actions',
        edit: 'Edit',
        preview: 'Recipe preview',
        delete: 'Delete'
      }
    },
    addCookDialog: {
      title: 'Add new cook',
      availableEditors: 'Available editors',
      assignedEditors: 'Assigned editors',
      labels: {
        name: 'Cook name',
        id: 'Name id',
        logoUpload: 'Drop file here or click to upload cook logo'
      },
      success: {
        create: 'Cook {name} created successfully.',
        update: 'Cook {name} updated successfully.'
      },
      placeholders: {
        name: 'Insert cook name'
      },
      rules: {
        requiredName: 'Cook name is required',
        required: 'This field is required',
        seoIdRule: 'Name Id can only contain lowercase letters, numbers and "-" sign',
        cookNameTaken: 'Cook with the given name already exists.'
      },
      statusList: {
        INACTIVE: 'Inactive',
        READY_FOR_ACTIVATION: 'Ready for activation',
        READY_FOR_DISACTIVATION: 'Ready for disactivation',
        ACTIVE: 'Active'
      },
      footerButtons: {
        cancel: 'Cancel',
        create: 'Add cook',
        update: 'Save changes'
      }
    },
    recipes: {
      publish: {
        button: 'Publish recipes',
        confirm: 'Do you really want to publish recipes?',
        success: 'Recipes published successfully.'
      },
      showAll: 'Expand all recipes',
      hideAll: 'Shrink all recipes',
      delete: {
        confirm: 'Do you really want to delete this recipe?'
      }
    },
    cooks: {
      addRecipe: 'Add recipe',
      editCook: 'Edit cook',
      deleteCook: 'Delete cook',
      addCook: 'Add cook',
      delete: {
        confirm: 'Do you really want to delete cook: {cook}?',
        success: 'Cook {cook} deleted successfully.'
      },
      collapseRecipes: 'Shrink recipes',
      expandRecipes: 'Expand recipes',
      fetching: 'Loading cooks...',
      noCooks: 'No cooks to display!',
      noCooksDetails: 'Add the first cook to view his details.'
    },
    recipePreview: {
      title: 'Recipe preview',
      noImage: 'No image',
      preparationMinutes: 'Minutes',
      portionFor: 'For {number} people',
      complexity: {
        easy: 'Easy',
        medium: 'Medium',
        hard: 'Hard'
      },
      summarizeHeader: 'Done? Enjoy your meal!',
      summarizeText: 'Add a dish to the Cooked to always have it within reach.'
    }
  },
  loyaltyCards: {
    addCard: 'Добавить карту',
    editCard: 'Редактировать карту',
    deleteCard: 'Удалить карту',
    cardId: 'ID карты',
    cardName: 'Название карты',
    store: 'Магазин',
    storeId: 'ID магазина',
    legacyId: 'ID legacy',
    color: 'Цвет',
    cardImages: 'Изображения карты',
    cardImage: 'Изображение карты',
    uploadImage: 'Загрузить изображение',
    uploadImageHint: 'Перетащите или нажмите для загрузки',
    changeImage: 'Изменить',
    removeImage: 'Удалить',
    isPopular: 'Популярная',
    popular: 'Популярная',
    edit: 'Редактировать',
    noCards: 'Карты лояльности не найдены',
    selectCountry: 'Выберите страну',
    createSuccess: 'Карта лояльности успешно создана',
    updateSuccess: 'Карта лояльности успешно обновлена',
    deleteSuccess: 'Карта лояльности успешно удалена',
    placeholders: {
      cardId: 'Введите ID карты (только строчные буквы, цифры и дефисы)',
      cardName: 'Введите название карты',
      selectStore: 'Выберите магазин',
      selectColor: 'Выберите цвет'
    },
    validation: {
      cardIdRequired: 'ID карты обязательно',
      cardIdMinLength: 'ID карты должен содержать не менее 2 символов',
      cardIdMaxLength: 'ID карты может содержать максимум 50 символов',
      cardIdInvalidFormat: 'ID карты может содержать только строчные буквы, цифры и дефисы',
      cardNameRequired: 'Название карты обязательно',
      cardNameMinLength: 'Название карты должно содержать не менее 2 символов',
      cardNameMaxLength: 'Название карты может содержать максимум 50 символов',
      colorRequired: 'Выбор цвета обязателен',
      imageRequired: 'Изображение карты обязательно',
      imageInvalidType: 'Пожалуйста, загрузите действительный файл изображения'
    },
    deleteConfirm: 'Вы действительно хотите удалить эту карту лояльности?',
    errorFetching: 'Ошибка при получении карт лояльности',
    errorCreating: 'Ошибка при создании карты лояльности',
    errorUpdating: 'Ошибка при обновлении карты лояльности',
    errorDeleting: 'Ошибка при удалении карты лояльности'
  },
  scrapper: {
    tabs: {
      zipTabName: 'ZIP file',
      pdfTabName: 'Generate pdf link'
    },
    pdf: {
      urlInputPlaceholder: 'URL to .pdf',
      downloadButtonLabel: 'Generate .pdf link',
      copyLink: 'Copy link to the clipboard',
      linkToFile: 'Link to file:',
      copySuccess: 'Link to .pdf copied to the clipboard',
      copyError: 'Copying link to .pdf failed'
    },
    zip: {
      urlInputPlaceholder: 'Leaflet URL',
      urlInputPrefixPlaceholder: 'Leaflet Prefix',
      downloadButtonLabel: 'Download',
      ifDownloadDidntStart: "If downloading didn't start automatically",
      clickHere: 'click here'
    }
  },
  slider: {
    title: 'Слайдер',
    addSlide: 'Добавить новый слайд',
    editSlide: 'Редактировать слайд',
    deleteSlide: 'Удалить слайд',
    activeCount: 'Активные: {count}',
    inactiveCount: 'Неактивные: {count}',
    noSlides: 'Нет слайдов для отображения',
    errorFetching: 'Ошибка загрузки слайдов',
    errorCreating: 'Ошибка создания слайда',
    errorUpdating: 'Ошибка обновления слайда',
    errorDeleting: 'Ошибка удаления слайда',
    errorReordering: 'Ошибка изменения порядка слайда',
    createSuccess: 'Слайд успешно создан',
    updateSuccess: 'Слайд успешно обновлен',
    deleteSuccess: 'Слайд успешно удален',
    deleteConfirm: 'Вы уверены, что хотите удалить этот слайд?',
    deleteDialog: {
      title: 'Удалить слайд',
      message: 'Что вы хотите сделать с этим слайдом?',
      delete: 'Удалить навсегда',
      markAsDraft: 'Отметить как черновик',
      cancel: 'Отмена'
    },
    markAsDraftSuccess: 'Слайд отмечен как черновик',
    form: {
      title: 'Добавить слайд',
      editTitle: 'Редактировать слайд',
      slideType: {
        label: 'Тип слайда',
        placeholder: 'Выберите тип слайда',
        image: 'Изображение',
        gif: 'GIF'
      },
      uploadImage: 'Нажмите или перетащите файл для добавления',
      uploadGif: 'Нажмите или перетащите файл GIF для добавления',
      description: {
        label: 'Описание',
        placeholder: 'Введите описание слайда'
      },
      name: {
        label: 'Название',
        placeholder: 'Введите название слайда'
      },
      redirect: {
        label: 'URL перенаправления',
        placeholder: 'Введите URL перенаправления'
      },
      position: {
        label: 'Позиция',
        placeholder: 'Введите позицию'
      },
      status: {
        label: 'Статус',
        placeholder: 'Выберите статус'
      },
      validityPeriod: 'Период действия',
      validFrom: {
        label: 'С',
        placeholder: 'Выберите дату и время'
      },
      validTo: {
        label: 'До',
        placeholder: 'Выберите дату и время'
      },
      publishedAt: {
        label: 'Публикация',
        placeholder: 'Выберите дату и время'
      },
      note: {
        label: 'Заметка',
        placeholder: 'Добавить заметку'
      },
      showOn: 'Показать на:',
      tracking: {
        title: 'Отслеживание',
        views: 'Просмотры',
        clicks: 'Клики',
        trackingUrlView: {
          label: 'URL отслеживания (Просмотры)',
          placeholder: 'Введите URL отслеживания для просмотров'
        },
        trackingUrlClick: {
          label: 'URL отслеживания (Клики)',
          placeholder: 'Введите URL отслеживания для кликов'
        }
      },
      buttons: {
        cancel: 'Отмена',
        save: 'Сохранить'
      },
      uploadLimit: 'Можно загрузить только один файл'
    },
    rules: {
      imageRequired: 'Изображение обязательно',
      gifRequired: 'Файл GIF обязателен',
      nameRequired: 'Название обязательно',
      statusRequired: 'Статус обязателен',
      validFromRequired: 'Дата начала обязательна',
      redirectUrlInvalid: 'Неверный формат URL',
      positionInvalid: 'Позиция должна быть числом больше или равным 0'
    },
    table: {
      name: 'Название',
      redirect: 'Перенаправление',
      trackingUrl: 'URL отслеживания',
      added: 'Добавлен',
      updated: 'Обновлен',
      position: 'Позиция',
      validFrom: 'Действителен с',
      validTo: 'Действителен до',
      visibility: 'Видимость',
      status: 'Статус',
      actions: 'Действия',
      noData: 'Нет данных',
      none: 'нет'
    },
    status: {
      active: 'Активный',
      inactive: 'Неактивный',
      draft: 'Черновик'
    },
    platforms: {
      web: 'Web',
      ios: 'iOS',
      android: 'Android',
      mpromocje: 'mPromocje'
    },
    aspectRatio: {
      '16x9': '16:9',
      '4x3': '4:3',
      '1x1': '1:1'
    },
    filters: {
      title: 'Фильтры',
      clear: 'Очистить',
      clearAll: 'Очистить все фильтры',
      apply: 'Применить',
      activeFilters: 'Активные фильтры',
      showActive: 'Показать активные слайдеры',
      showVisibleNow: 'Видимые клиентам',
      visibleNow: 'Видимые клиентам',
      platform: {
        title: 'Фильтр по платформе'
      },
      status: {
        title: 'Фильтр по статусу',
        all: 'Все',
        active: 'Активные',
        draft: 'Черновики',
        expired: 'Истекшие'
      }
    },
    sorting: {
      sortBy: 'Сортировать по',
      ascending: 'По возрастанию',
      descending: 'По убыванию'
    }
  },
  tradeDays: {
    title: 'Торговые дни',
    status: 'Статус',
    statusList: {
      STORES_CLOSED: 'Магазины закрыты',
      STORES_OPENED: 'Магазины открыты',
      CUSTOM: 'Пользовательский',
      NOT_APPLICABLE: 'Не применимо'
    },
    months: {
      0: 'Январь',
      1: 'Февраль',
      2: 'Март',
      3: 'Апрель',
      4: 'Май',
      5: 'Июнь',
      6: 'Июль',
      7: 'Август',
      8: 'Сентябрь',
      9: 'Октябрь',
      10: 'Ноябрь',
      11: 'Декабрь'
    },
    weekDays: {
      Mon: 'Пн',
      Tue: 'Вт',
      Wed: 'Ср',
      Thu: 'Чт',
      Fri: 'Пт',
      Sat: 'Сб',
      Sun: 'Вс'
    },
    modal: {
      createTitle: 'Создать торговый день',
      editTitle: 'Редактировать торговый день'
    },
    form: {
      date: 'Дата',
      selectDate: 'Выберите дату',
      status: 'Статус',
      localizedFields: 'Локализованные поля',
      title: 'Заголовок',
      titlePlaceholder: 'Введите заголовок',
      tip: 'Подсказка',
      tipPlaceholder: 'Введите подсказку',
      customDescription: 'Пользовательское описание',
      customDescriptionPlaceholder: 'Введите пользовательское описание',
      copyFromDay: 'Копировать из другого дня',
      copyFromDayDescription: 'Скопируйте значения из существующего торгового дня для заполнения пустых полей'
    },
    copyDialog: {
      title: 'Копировать из другого дня',
      selectYear: 'Выберите год',
      selectDate: 'Выберите дату для копирования',
      preview: 'Предпросмотр',
      noDataForYear: 'Нет торговых дней для {year}',
      noDaysAvailable: 'Нет доступных торговых дней для копирования',
      copyButton: 'Копировать в форму',
      cancel: 'Отмена',
      emptyField: 'Не установлено',
      previewDate: 'Дата',
      previewStatus: 'Статус',
      previewTitles: 'Заголовки',
      previewTips: 'Подсказки',
      previewDescriptions: 'Описания'
    },
    validation: {
      dayDateRequired: 'Дата обязательна',
      dayStatusRequired: 'Статус обязателен',
      dayStatusInvalid: 'Недопустимое значение статуса',
      maxLength: 'Максимальная длина {max} символов',
      fieldMaxLength: '{field} превышает максимальную длину {max} символов'
    },
    messages: {
      createSuccess: 'Торговый день успешно создан',
      updateSuccess: 'Торговый день успешно обновлен',
      deleteSuccess: 'Торговый день успешно удален',
      copySuccess: 'Значения скопированы из {date}',
      copyOnlyEmptyFields: 'Заполнены только пустые поля'
    },
    errors: {
      fetchFailed: 'Не удалось загрузить торговые дни',
      createFailed: 'Не удалось создать торговый день',
      updateFailed: 'Не удалось обновить торговый день',
      deleteFailed: 'Не удалось удалить торговый день'
    },
    deleteConfirm: {
      title: 'Удалить торговый день',
      message: 'Вы уверены, что хотите удалить этот торговый день? Это действие нельзя отменить.'
    },
    bulkUpdate: {
      buttonLabel: 'Массовое обновление',
      daysOfWeek: {
        monday: 'Понедельник',
        tuesday: 'Вторник',
        wednesday: 'Среда',
        thursday: 'Четверг',
        friday: 'Пятница',
        saturday: 'Суббота',
        sunday: 'Воскресенье'
      },
      form: {
        dayOfWeek: 'День недели',
        selectDayOfWeek: 'Выберите день недели',
        dateRange: 'Диапазон дат',
        entireYear: 'Весь год',
        customRange: 'Пользовательский диапазон',
        year: 'Год',
        customDateRange: 'Пользовательский диапазон дат',
        startDate: 'Дата начала',
        endDate: 'Дата окончания',
        tradeDaySettings: 'Настройки торгового дня'
      },
      dialog: {
        title: 'Массовое обновление торговых дней',
        titleConfigure: 'Массовое обновление - Настройка',
        titlePreview: 'Массовое обновление - Предпросмотр',
        titleConfirm: 'Массовое обновление - Подтверждение',
        cancel: 'Отмена',
        previewDates: 'Предпросмотр дат',
        back: 'Назад',
        proceedToConfirm: 'Перейти к подтверждению'
      },
      preview: {
        summary: 'Сводка',
        totalAffected: 'Всего затронутых дат',
        newEntries: 'Новые записи',
        overwrites: 'Перезаписи',
        affectedDates: 'Затронутые даты',
        new: 'Новый',
        willOverwrite: 'Будет перезаписан',
        showAllDates: 'Показать все {count} дат',
        showLess: 'Показать меньше',
        overwriteWarning: 'Предупреждение о перезаписи',
        overwriteWarningMessage: '{count} существующих торговых дней будут перезаписаны новыми значениями.',
        infoTitle: 'Проверьте перед продолжением',
        infoMessage:
          'Пожалуйста, внимательно проверьте затронутые даты. На следующем шаге вам нужно будет подтвердить это действие.'
      },
      confirmation: {
        title: 'Подтвердите массовое обновление',
        warningTitle: 'Предупреждение: Это действие нельзя отменить',
        warningMessage: 'Вы собираетесь выполнить операцию массового обновления:',
        totalDates: 'Всего дат для обновления: {count}',
        overwriteCount: '{count} существующих торговых дней будут перезаписаны',
        cannotUndo: 'Это действие нельзя отменить',
        summaryTitle: 'Сводка операции',
        typeToConfirm: 'Введите "{text}" для подтверждения:',
        confirmationMismatch: 'Пожалуйста, введите CONFIRM точно как показано выше',
        cancel: 'Отмена',
        confirmButton: 'Подтвердить и выполнить'
      },
      validation: {
        dayOfWeekRequired: 'День недели обязателен',
        yearRequired: 'Год обязателен',
        fromDateRequired: 'Дата начала обязательна',
        toDateRequired: 'Дата окончания обязательна',
        toDateBeforeFromDate: 'Дата окончания должна быть позже даты начала',
        noMatchingDates: 'Нет дат, соответствующих выбранным критериям'
      },
      messages: {
        successCount: '{count} торговых дней успешно обновлено',
        failureCount: '{count} торговых дней не удалось обновить'
      }
    }
  },
  marketingFileUpload: {
    dropZoneText: 'Перетащите файлы сюда или нажмите для выбора',
    dropZoneHint: 'Допустимые: {extensions}',
    filesReady: '{count} файл(ов) готово',
    totalSize: '{size} всего',
    clearAll: 'Очистить всё',
    upload: 'Загрузить {count} файл(ов)',
    cancel: 'Отмена',
    currentFile: 'Текущий файл',
    removeFile: 'Удалить {name}',
    confirmTitle: 'Подтвердите загрузку',
    confirmMessage: 'Загрузить {count} файлов ({size}) в кампанию "{campaign}"?',
    uploadSuccess: 'Файл загружен успешно | {count} файлов загружено успешно',
    uploadError: 'Ошибка загрузки файла',
    partialSuccess: '{success} из {total} файлов загружено. {failed} не удалось.',
    validationErrors: {
      invalidType: 'Тип файла "{ext}" не разрешён',
      fileTooLarge: 'Размер файла {size} превышает максимум {max}',
      maxFilesExceeded: 'Максимум {max} файлов'
    }
  },
  hotkeys: {
    title: 'Горячие клавиши',
    previousPage: 'Предыдущая страница',
    nextPage: 'Следующая страница',
    newArticle: 'Новая статья',
    closeDialog: 'Закрыть окно',
    saveArticle: 'Сохранить статью',
    cancelEditing: 'Отменить редактирование',
    showHelp: 'Показать горячие клавиши',
    dashboard: {
      moveDown: 'Переместить фокус вниз',
      moveUp: 'Переместить фокус вверх',
      enterLeaflets: 'Открыть список листовок',
      exitLeaflets: 'Выйти из списка листовок',
      clearFocus: 'Сбросить фокус',
      focusSearch: 'Фокус на поиск',
      primaryAction: 'Переключить список / Редактировать листовку',
      addLeaflet: 'Добавить листовку',
      editStore: 'Редактировать магазин',
      delete: 'Удалить выбранный элемент',
      activateAllLeaflets: 'Активировать все листовки',
      goToPageDetails: 'Перейти к переадресациям и инсертам',
      openPageDetailsImages: 'Открыть изображения страниц',
      openArticlesData: 'Открыть данные статей',
      syncLongUrl: 'Синхронизировать длинный URL',
      copySeoId: 'Копировать SEO ID'
    },
    menuNavigation: 'Открыть навигацию по меню',
    menuNav: {
      hintRoot: 'Нажмите букву для навигации',
      hintEsc: 'Esc для отмены',
      hintBack: 'Esc чтобы вернуться',
      back: 'Назад'
    }
  }
}
